<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- desktop-->
    <core-card [actions]="[]" *ngIf="_utilService.isDesktop">
      <div class="card-title w-100">
        <div class="float-left row pl-1">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="float-right">
          <div class="d-inline-block mr-2">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addNewSource, null)" *ngIf="_authenticationService.hasCapability('create_candidate_source')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="config.scrollbarH"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="config.rowHeight"
          [limit]="tableLimit"
          [footerHeight]="config.footerHeight"
          [rows]="sourceList()"
        >
          <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value" [width]="col.width || null" [sortable]="col.sortable || false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row[col.value] }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button (click)="modalOpen(editSources, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_candidate_source')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="delete(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_candidate_source')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
    <!--mobile - tablet -->
    <core-card [actions]="[]" *ngIf="_utilService.isMobile || _utilService.isTablet">
      <!-- cerca-->
      <div class="card-title d-flex flex-column w-100">
        <div class="pb-1">
          <label class="w-100">
            <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="d-flex justify-content-end">
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addNewSource, null)">{{ "ADD" | translate }}</a>
        </div>
      </div>
      <!-- tabella-->
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="config.scrollbarH"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="90"
          [limit]="tableLimit"
          [rows]="sourceList()"
        >
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="name" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center list-item-mobile">
                <span class="col-10">{{ row.name }}</span>
                <div class="d-flex flex-column col-2 pl-0">
                  <button (click)="modalOpen(editSources, row)" class="bg-transparent border-0 text-secondary mb-05" *ngIf="_authenticationService.hasCapability('edit_candidate_source')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="delete(row)" *ngIf="_authenticationService.hasCapability('delete_candidate_source')" class="bg-transparent border-0 text-danger remove-item">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>
<!-- Modal ADD -->
<ng-template #addNewSource let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.INSERT_SOURCE" | translate }}</h3>
    <label [for]="'new_source'">{{ "SOURCE" | translate }}<sup class="text-danger">*</sup></label>
    <input name="new_source" [(ngModel)]="new_source" type="text" [id]="new_source" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!new_source || new_source.length < 1)">{{ "ERRORS.FIELD_SOURCE" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="addSource()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "ERRORS.INSERT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal ADD -->

<!-- Modal EDIT -->
<ng-template #editSources let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.EDIT_SOURCE" | translate }}</h3>
    <label [for]="currentSource.name">{{ "SOURCE" | translate }}<sup class="text-danger">*</sup></label>
    <input name="currentSourceName" [(ngModel)]="currentSource.name" type="text" [id]="currentSource.name" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!currentSource.name || currentSource.name.length < 1)">{{ "ERRORS.FIELD_SOURCE" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="editSource()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal EDIT -->
